import React, { Component } from 'react';
import './App.css';
import { Store } from './lib';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react'
import { default as Loader } from './loader';

const store = Store.instance.getStore();
const persistor = Store.instance.getPersistor();

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Loader />
        </PersistGate>
      </Provider>
    );
  }
}

export default App;
